var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavLevels(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_388_1839)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.75 0H5.25C3.18225 0 1.5 1.68225 1.5 3.75V15C1.5 16.6545 2.8455 18 4.5 18H12.75C14.8178 18 16.5 16.3177 16.5 14.25V3.75C16.5 1.68225 14.8178 0 12.75 0ZM15 3.75V12H6V1.5H9V7.76025C9 8.2275 9.59325 8.42775 9.87675 8.0565L10.875 6.74925L11.8733 8.0565C12.1568 8.42775 12.75 8.2275 12.75 7.76025V1.5C13.9905 1.5 15 2.5095 15 3.75ZM4.5 1.638V12C3.951 12 3.44325 12.159 3 12.417V3.75C3 2.7735 3.62925 1.9485 4.5 1.638ZM12.75 16.5H4.5C2.52825 16.4648 2.52975 13.5345 4.5 13.5H15V14.25C15 15.4905 13.9905 16.5 12.75 16.5Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_388_1839"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavLevels);
export default __webpack_public_path__ + "static/media/nav-levels.9d3b644b0cc2fbd8e368d7d42c136eb9.svg";
export { ForwardRef as ReactComponent };